<template>
  <cube-popup
    v-show="visible"
    type="my-popup"
    :center="false"
    position="right"
    class="filter-wrap"
  >
    <div class="level-cascash-content">
      <div
        v-if="type!=='follow'"
        class="default-item"
        @click="handleSelectLevel({name:allLevel,id:-1})"
      >
        <span class="text">{{ allLevel }}</span>
      </div>
      <div v-if="type!=='follow'">
        <div
          v-for=" items in levelList"
          :key="items.id"
          class="default-item"
          @click="handleSelectLevel(items)"
        >
          <span class="text">{{ items.name }}</span>
        </div>
      </div>
      <div v-else>
        <div
          v-for=" (items,index) in followFilterDataList"
          :key="items.sortId"
          class="default-item"
          @click="handleSelectLevel(`${items.name}-${index+2}`)"
        >
          <span class="text">{{ items.name }}</span>
        </div>
      </div>
    </div>
  </cube-popup>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapState('statistic', ['levelList', 'followFilterDataList']),
    allLevel () {
      return this.$t('message["905"]')
    }
  },
  mounted () {
    if (this.type !== 'follow') {
      this.fetchGetLevelList()
    }
  },
  methods: {
    ...mapActions('statistic', ['fetchGetLevelList']),
    handleSelectLevel (val) {
      this.$emit('levelSelect', val)
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.filter-wrap::v-deep {
  .level-cascash-content {
    margin-top: 12px;
    width: 375px;
    height: 100%;
    .default-item {
      height: 48px;
      background-color: #fff;
      border-bottom: solid 1px rgba(219, 219, 219, 1);
      .text {
        width: 64px;
        height: 48px;
        font-size: 16px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 48px;
        text-align: left;
        margin-left: 12px;
      }
    }
  }
}
</style>
